import React, { ChangeEvent, useEffect, useState } from "react";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import { OrderDetails } from "../DashboardOrderEntry/DashboardOrderEntry";

type Props = {
    editMode: boolean;
    updateOrderDetails: (details: OrderDetails) => void;
};

export const DashboardOrderEntryDetails = (props: Props) => {
    const [poNumber, setPoNumber] = useState<string>("");
    const [isLocalPickup, setIsLocalPickup] = useState(false);
    const [isLocalDelivery, setIsLocalDelivery] = useState(false);
    const [notes, setNotes] = useState("");
    const [internalNotes, setInternalNotes] = useState("");

    useEffect(() => {
        if (!props.editMode) {
            const details: OrderDetails = {
                poNumber,
                isLocalPickup,
                isLocalDelivery,
                notes,
                internalNotes,
            };

            props.updateOrderDetails(details);
        }
    }, [props.editMode]);

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        switch (name) {
            case "poNumber":
                setPoNumber(value);
                break;

            case "isLocalPickup":
                setIsLocalPickup(value);
                break;

            case "isLocalDelivery":
                setIsLocalDelivery(value);
                break;

            case "notes":
                setNotes(value);
                break;

            case "internalNotes":
                setInternalNotes(value);
                break;
        }
    };

    return (
        <div className={"DashboardOrderEntryDetails"}>
            <div>
                <OwLabel title={"po_no"} postText={":"} isBold={true} className={"me-2"} />
                {props.editMode ? <OwFnInput fn={handleChange} value={poNumber} name={"poNumber"} /> : poNumber}
            </div>
            <div>
                <OwLabel title={"local_pickup"} postText={":"} isBold={true} className={"me-2"} />
                {props.editMode ? (
                    <OwCheckbox name={"isLocalPickup"} fn={handleChange} truthyVal={true} falsyVal={false} checked={isLocalPickup} />
                ) : isLocalPickup ? (
                    "Y"
                ) : (
                    "N"
                )}
            </div>
            <div>
                <OwLabel title={"local_delivery"} postText={":"} isBold={true} className={"me-2"} />
                {props.editMode ? (
                    <OwCheckbox name={"isLocalDelivery"} fn={handleChange} truthyVal={true} falsyVal={false} checked={isLocalDelivery} />
                ) : isLocalDelivery ? (
                    "Y"
                ) : (
                    "N"
                )}
            </div>
            <div>
                <OwLabel title={"notes"} postText={":"} isBold={true} className={"me-2"} />
                {props.editMode ? <OwTextArea fn={handleChange} value={notes} name={"notes"} /> : notes}
            </div>
            <div>
                <OwLabel title={"internal_notes"} postText={":"} isBold={true} className={"me-2"} />
                {props.editMode ? <OwTextArea fn={handleChange} value={internalNotes} name={"internalNotes"} /> : internalNotes}
            </div>
        </div>
    );
};
